import { combineReducers } from 'redux';

import testsReducer from './reducers/tests';
import errorsReducer from './reducers/errors';
import buildsReducer from './reducers/builds';

const reducers = {
  tests: testsReducer,
  errors: errorsReducer,
  builds: buildsReducer,
};

export default combineReducers(reducers);
